// Theme presets — complete looks applied in one click. Applying a preset
// COPIES its values into the form's theme (presetId is a memo of where the
// look came from, not a live link), so editing after applying never mutates
// the preset and a renamed preset never restyles old forms.
export interface ThemePreset {
  id: string;
  name: string;
  accent: string;
  bg: string;
  mode: 'light' | 'dark';
  font?: { body?: string; heading?: string };
}

export const THEME_PRESETS: ThemePreset[] = [
  {
    id: 'classic', name: 'Classic', accent: '#667eea',
    bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', mode: 'light',
  },
  {
    id: 'minimal', name: 'Minimal', accent: '#2d3748', bg: '#f7fafc', mode: 'light',
    font: { body: 'Inter', heading: 'Inter' },
  },
  {
    id: 'ocean', name: 'Ocean', accent: '#0987a0',
    bg: 'linear-gradient(135deg, #667db6 0%, #0082c8 100%)', mode: 'light',
    font: { body: 'Open Sans', heading: 'Montserrat' },
  },
  {
    id: 'forest', name: 'Forest', accent: '#2f855a',
    bg: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)', mode: 'light',
    font: { body: 'Lato', heading: 'Lato' },
  },
  {
    id: 'sunset', name: 'Sunset', accent: '#dd6b20',
    bg: 'linear-gradient(135deg, #f6ad55 0%, #ed64a6 100%)', mode: 'light',
    font: { body: 'Nunito', heading: 'Poppins' },
  },
  {
    id: 'editorial', name: 'Editorial', accent: '#9b2c2c', bg: '#fffaf0', mode: 'light',
    font: { body: 'Source Serif 4', heading: 'Playfair Display' },
  },
  {
    id: 'midnight', name: 'Midnight', accent: '#7f9cf5', bg: '#1a202c', mode: 'dark',
    font: { body: 'Inter', heading: 'Inter' },
  },
  {
    id: 'terminal', name: 'Terminal', accent: '#48bb78', bg: '#0f1419', mode: 'dark',
    font: { body: 'IBM Plex Sans', heading: 'IBM Plex Sans' },
  },
];
